import { ChainID } from '@ankr.com/chains-list';

const opnodes: ChainID[] = [
  ChainID.ROLLUX_OPNODE,
  ChainID.ROLLUX_OPNODE_TESTNET,
];

export const isOpnode = (chainID?: ChainID) =>
  !!chainID && opnodes.includes(chainID);
